var render = function render(){var _vm=this,_c=_vm._self._c;return _c('surroundBox',{attrs:{"name":_vm.description,"desc":"废弃物加工得到的产品产量"}},[_c('template',{slot:"content"},[_c('highcharts',{staticStyle:{"width":"100%","height":"100%"},attrs:{"callback":_vm.loadData,"options":_vm.chartOptions}})],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }